import React from 'react';
import { clsx } from 'clsx';
import { CheckIcon } from '@heroicons/react/24/solid';
import type { PublicPlanDefinition } from '../../types/platformOrganization';
import { buildPlanFeatureList } from '../../utils/planFeatures';
import { StripeCheckoutLink } from '../StripeCheckoutLink';
import { PlanTierBadge } from './PlatformBadges';

interface PlanReferenceCardsProps {
  plans: PublicPlanDefinition[];
}

export const PlanReferenceCards: React.FC<PlanReferenceCardsProps> = ({ plans }) => {
  const ordered = ['BASIC', 'PROFESSIONAL', 'PREMIUM']
    .map((tier) => plans.find((p) => p.tier === tier))
    .filter(Boolean) as PublicPlanDefinition[];

  return (
    <div className="grid gap-4 md:grid-cols-3">
      {ordered.map((plan) => {
        const highlighted = plan.tier === 'PROFESSIONAL';
        const features = buildPlanFeatureList(plan);
        return (
          <div
            key={plan.tier}
            className={clsx(
              'relative rounded-2xl border p-5 transition-shadow',
              highlighted
                ? 'border-amber-300/80 bg-white shadow-md ring-2 ring-amber-200/60'
                : 'border-slate-200/90 bg-white shadow-sm'
            )}
          >
            {highlighted && (
              <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 rounded-full bg-amber-600 px-3 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
                Recomendado
              </span>
            )}
            <div className="flex items-center justify-between gap-2 mb-3">
              <PlanTierBadge tier={plan.tier} label={plan.label} />
              <span className="text-lg font-bold text-slate-900 tabular-nums">
                ${plan.priceUsd}
                <span className="text-xs font-normal text-slate-500">/mes</span>
              </span>
            </div>
            <ul className="space-y-2 mb-4">
              {features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-xs text-slate-600">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-emerald-600 mt-0.5" />
                  {f}
                </li>
              ))}
            </ul>
            {plan.stripeCheckoutUrl ? (
              <StripeCheckoutLink
                href={plan.stripeCheckoutUrl}
                variant={highlighted ? 'primary' : 'outline'}
                className="w-full"
              >
                Pagar ${plan.priceUsd}/mes
              </StripeCheckoutLink>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default PlanReferenceCards;
